import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';
import ComponentTitle from '../shared/ComponentTitle';
import ReadMoreButton from '../shared/ReadMoreButton';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import convert from 'xml-js';
import SliderArticleList from 'components/news/SliderArticleList';

const VideoPlayerPropTypes = {
  FRN_rawResponses: PropTypes.array,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  videoBackgroundColor: PropTypes.string,
  width: PropTypes.string,
  enableModal: PropTypes.bool,
  destinationUrl: PropTypes.string,
  textColor: PropTypes.string,
  autoPlayVideo: PropTypes.bool,
  categoryUrl: PropTypes.string,
  showReadMore: PropTypes.bool,
  readMoreText: PropTypes.string,
  readMoreBackgroundColor: PropTypes.string,
  readMoreTextColor: PropTypes.string,
  defaultThumbnail: PropTypes.string,
  titleType: PropTypes.string
};

class VideoPlayerWrapper extends Component {
  static propTypes = {
    destinationUrl: PropTypes.string,
    FRN_resourceEndpoints: PropTypes.array,
    FRN_rawResponses: PropTypes.array,
    isSlider: PropTypes.bool
  }

  render() {
    const {
      destinationUrl,
      FRN_resourceEndpoints: [{
        type = 'xml'
      }] = [{}],
      FRN_rawResponses,
      isSlider
    } = this.props;

    if (destinationUrl) {
      return isSlider ? <SliderVideoPlayer {...this.props} /> : <VideoPlayer {...this.props}/>;
    }

    if (_.isEmpty(FRN_rawResponses)) {
      return null;
    }

    return type === 'json' ? <SliderVideoPlayer {...this.props} /> : <VideoPlayer {...this.props}/>;
  }
}

class VideoPlayer extends Component {
  static propTypes = {
    ...VideoPlayerPropTypes
  }

  static defaultProps = {
    videoBackgroundColor: '#808080',
    textColor: '#000000',
    enableModal: false,
    autoPlayVideo: true,
    width: '100%',
    showReadMore: false,
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  state = {
    showModal: false,
    playVideo: this.props.autoPlayVideo && !this.props.enableModal
  }

  _updateModalVisibility() {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  _playVideo() {
    this.setState({
      playVideo: true
    });
  }

  _cleanXmlObj(entry = {}) {
    let item = Array.isArray(entry) ? entry[0] : entry;

    try {
      let cleanup = (obj) => obj ? Object.assign({}, ...obj._attributes, {"@url": obj._attributes.url}) : obj;

      let mediaContent = item["media:group"] && item["media:group"]["media:content"] 
          ? item["media:group"]["media:content"] 
          : (item["media:content"] ? item["media:content"] : {});

      if (Array.isArray(mediaContent)) {
        mediaContent = mediaContent.map(cleanup);
      } else if (typeof mediaContent === 'object') {
        mediaContent = cleanup(mediaContent);
      }

      return {
        ...item,
        "media:group": [{"media:content": mediaContent}],
        "media:content": mediaContent,
        "media:thumbnail": item["media:thumbnail"].map(cleanup),
        "media:title": item["media:title"]._cdata,
      };
    } catch (error) {
      console.log('>>> ERROR', error);
      return item ? item : {};
    }
  }

  render() {
    const {
      destinationUrl,
      FRN_rawResponses
    } = this.props;

    if (!destinationUrl && _.isEmpty(FRN_rawResponses)) {
      return null;
    }

    let data = {};
    let weatherVideoItem = {};

    let dataStr = _.get(FRN_rawResponses, '[0].data');
    try {
      if (dataStr && typeof dataStr === 'string') {
        data = convert.xml2js(dataStr, {compact: true});
        weatherVideoItem = this._cleanXmlObj(data.rss.channel.item);
      } else {
        weatherVideoItem = _.get(FRN_rawResponses, '[0].data.rss.channel.item', {});
      }
    } catch (error) {
      console.log(error);
    }

    weatherVideoItem = weatherVideoItem || {};
 
    const {
      // FRN_rawResponses: [
      //   {
      //     data: {
      //       rss: {
      //         channel: {
      //           item: weatherVideoItem = {}
      //         } = {}
      //       } = {}
      //     } = {}
      //   } = {}
      // ] = [],
      title,
      titleColor,
      videoBackgroundColor,
      autoPlayVideo,
      width,
      textColor,
      enableModal,
      categoryUrl,
      showReadMore,
      readMoreText,
      readMoreBackgroundColor,
      readMoreTextColor,
      defaultThumbnail,
      titleType
    } = this.props;

    const { showModal, playVideo } = this.state;

    const weatherVideo = _.isArray(weatherVideoItem) ? weatherVideoItem[0] : weatherVideoItem;

    const {
      'media:group': {
        'media:content': [{
          "@url": mediaGroupUrl = ''
        }] = [{}]
      } = {},
      'media:content': mediaContent = {},
      'media:thumbnail': [{
        "@url": thumbnailImage = ''
      }] = [{}],
      'media:title': mediaTitle = ''
    } = weatherVideo || {};

    const { "@url": mediaUrl } = _.isArray(mediaContent) ? mediaContent[0] : mediaContent;

    const videoThumbnailImage = thumbnailImage || defaultThumbnail;
    const controlsAutoPlay = !enableModal && (autoPlayVideo || playVideo);

    const videoProps = {
        src: destinationUrl || mediaGroupUrl || mediaUrl,
        thumbnailImage: videoThumbnailImage,
        title: mediaTitle
    };

    const showVideoIcon = enableModal || (!autoPlayVideo && !playVideo);

    return (
      <div className="VideoPlayer">
        {title && <ComponentTitle titleType={titleType} title={title} color={titleColor} classes="VideoPlayerModal-title" />}
        <div className="VideoPlayer-contentsWrapper" style={{width}} onClick={enableModal ? () => this._updateModalVisibility() : () => this._playVideo()}>
          {!videoThumbnailImage && !playVideo && <div style={{backgroundColor: videoBackgroundColor}} className="VideoPlayer-videoBackgroundColor"></div>}
          {showVideoIcon && <div className="VideoPlayer-icon"></div>}
          <Video play={playVideo} width={width} controls={controlsAutoPlay} autoPlay={controlsAutoPlay} {...videoProps} />
        </div>

        {enableModal ? <VideoPlayerModal
          showModal={showModal}
          {...videoProps}
          width="100%"
          textColor={textColor}
          onHideModal={() => this._updateModalVisibility()} /> : null}

        { showReadMore ?
          <ReadMoreButton
            link={categoryUrl}
            textColor={readMoreTextColor}
            text={readMoreText}
            backgroundColor={readMoreBackgroundColor} /> : null}

      </div>
    );
  }
}

class VideoPlayerModal extends Component {
  static propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
    thumbnailImage: PropTypes.string,
    width: PropTypes.string,
    textColor: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
    titleType: PropTypes.string,
    videoItems: PropTypes.array,
    continuousPlaying: PropTypes.bool,
    autoPlayVideo: PropTypes.bool,
    videoIndex: PropTypes.number,
    onPlayVideo: PropTypes.func
  }

  render() {
    const {
      showModal,
      title,
      src,
      thumbnailImage,
      width,
      textColor,
      onHideModal,
      videoItems,
      autoPlayVideo,
      continuousPlaying,
      videoIndex,
      onPlayVideo,
      titleType } = this.props;

      const numericWidth = /\%/.test(width) ? undefined : parseInt(width, 10); // strip units (px, em, etc) from width. undefine if width is a %

    return (
      <Modal className="VideoPlayerModal"
             show={showModal}
             onHide={onHideModal}
             backdrop
             aria-labelledby="contained-modal-title-lg">
        <Modal.Header className="VideoPlayerModal-header" closeButton>
        { title ? <ComponentTitle titleType={titleType} title={title} color={textColor} classes="VideoPlayerModal-title" /> : null }
        </Modal.Header>
        <Modal.Body>
          {src ? <Video width={width} poster={`${thumbnailImage}?auto=webp&disable=upscale&fit=crop&width=` + (numericWidth ?  numericWidth : '768')} src={src} controls autoPlay />
           : 
           <div className="Video">
            <div className="Video-wrapper">
              <div className="Video-content">
                <SliderVideo 
                  videoItems={videoItems}
                  autoPlayVideo={autoPlayVideo}
                  continuousPlaying={continuousPlaying}
                  videoIndex={videoIndex}
                  onPlayVideo={onPlayVideo}
                />
              </div>
            </div>
           </div>
          }
        </Modal.Body>
      </Modal>
    );
  }
}

class Video extends Component {
  static propTypes = {
    width: PropTypes.string,
    thumbnailImage: PropTypes.string,
    src: PropTypes.string.isRequired,
    controls: PropTypes.bool,
    autoPlay: PropTypes.bool,
    play: PropTypes.bool
  }

  static defaultProps = {
    width: '100%',
    thumbnailImage: null,
    controls: false,
    autoPlay: false,
    play: false
  }

  componentWillReceiveProps(nextProps){
    nextProps.play && this._playVideo();
  }

  _playVideo() {
    this.vidRef.play();
  }

  render() {
    const {
      width,
      thumbnailImage,
      src,
      controls,
      autoPlay } = this.props;

    const numericWidth = /\%/.test(width) ? undefined : parseInt(width, 10); // strip units (px, em, etc) from width. undefine if width is a %

    return (
      <video ref={(vidRef) => {this.vidRef = vidRef;}} poster={`${thumbnailImage}?auto=webp&disable=upscale&fit=crop&width=` + (numericWidth ?  numericWidth : '768')} style={{width}} controls={controls} autoPlay={autoPlay}>
        <source src={src} />
      </video>
    );
  }
}

class SliderVideoPlayer extends Component {
  static propTypes = {
    ...VideoPlayerPropTypes,
    maxLimit: PropTypes.number,
    showAdditionalVideos: PropTypes.bool,
    continuousPlaying: PropTypes.bool,
    sliderProps: PropTypes.object
  }

  static defaultProps = {
    videoBackgroundColor: 'transparent',
    textColor: '#000000',
    enableModal: false,
    autoPlayVideo: true,
    width: '100%',
    showReadMore: false,
    titleType: TITLE_TYPE.MODULE_TITLE,
    showAdditionalVideos: false,
    maxLimit: 1,
    continuousPlaying: true,
    sliderProps: {}
  }

  state = {
    showModal: false,
    videoIndex: 0
  }

  _updateModalVisibility() {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  _playVideo(videoIndex) {
    this.setState({
      videoIndex
    });
  }

  _playVideoModal(videoIndex) {
    this.setState({
      showModal: !this.state.showModal,
      videoIndex
    });
  }

  render() {
    const {
      FRN_rawResponses,
      title,
      titleColor,
      videoBackgroundColor,
      autoPlayVideo,
      textColor,
      enableModal,
      categoryUrl,
      showReadMore,
      readMoreText,
      readMoreBackgroundColor,
      readMoreTextColor,
      titleType,
      maxLimit,
      continuousPlaying,
      showAdditionalVideos,
      sliderProps
    } = this.props;

    const { showModal, videoIndex } = this.state;

    const items = _.get(FRN_rawResponses[0], 'data.features', []);
    const videoItems = _.filter(items, (item) => item.type === 'clip');

    const {
      headline = '',
      abstractimage: {
        filename: imageVideoUrl
      } = {}
    } = videoItems[videoIndex] || {};

    const videoProps = {
      videoItems: _.slice(videoItems, 0, maxLimit),
      autoPlayVideo,
      continuousPlaying,
      title: headline,
      videoIndex,
      onPlayVideo: (index) => this._playVideo(index)
    };

    const styles = enableModal ? {
      backgroundImage: `url(${imageVideoUrl})`
    } : {};

    return (
      <div className="VideoPlayer VideoPlayer-slider">
        {title && <ComponentTitle titleType={titleType} title={title} color={titleColor} classes="VideoPlayerModal-title" />}
        <div style={{backgroundColor: videoBackgroundColor}} >
        {
          videoItems.length > 0 && 
            <div className="Video Video-slider" style={styles} onClick={enableModal ? () => this._playVideoModal(videoIndex) : () => {}}>
              {enableModal && <div className="VideoPlayer-icon"></div>}
              <div className="Video-wrapper">
                <div className="Video-content">
                {
                  !enableModal && 
                  <SliderVideo 
                    {...videoProps}
                  />
                }
                </div>
              </div>
            </div>
        }
        {
          showAdditionalVideos &&
          <SliderArticleList
            {...sliderProps}
            FRN_rawResponses={FRN_rawResponses}
            showTitle={false}
            numberOfItems={maxLimit}
            types={['clip']}
            onPlayVideo={enableModal ? (index) => this._playVideoModal(index) : (index) => this._playVideo(index)}
            currentIndexVideo={videoIndex}
          />
        }
        </div>
        {enableModal ? <VideoPlayerModal
          showModal={showModal}
          {...videoProps}
          width="100%"
          textColor={textColor}
          onHideModal={() => this._updateModalVisibility()} /> : null}

        { showReadMore ?
          <ReadMoreButton
            link={categoryUrl}
            textColor={readMoreTextColor}
            text={readMoreText}
            backgroundColor={readMoreBackgroundColor} /> : null}
      </div>
    );
  }
}

class SliderVideo extends Component {
  
  static propTypes = {
    videoItems: PropTypes.array,
    continuousPlaying: PropTypes.bool,
    autoPlayVideo: PropTypes.bool,
    videoIndex: PropTypes.number,
    onPlayVideo: PropTypes.func
  }

  static defaultProps = {
    continuousPlaying: true,
    autoPlayVideo: true
  }

  state = {
    domCanvasId: _.uniqueId('divWNVideoCanvas'),
    clipId: this.props.videoItems[0].id
  }

  componentDidMount() {
    this._setup();
  }

  componentWillReceiveProps(newProps) {
    const { videoIndex } = newProps;
    const { videoItems } = this.props;
    const clipId = videoItems[videoIndex].id;

    this.setState({clipId}, () => {
        this._reRenderWidget(clipId);
    });
  }

  componentWillUnmount() {
    const { domCanvasId } = this.state;
    document.querySelector(`#${domCanvasId} video`).removeEventListener("ended", () => this._renderNextVideo());
  }
  
  _setup = () => {
    const { domCanvasId, clipId } = this.state;
    const { autoPlayVideo } = this.props;

    const wNVideoCanvas = new window.WNVideoWidget('WNVideoCanvas', domCanvasId);

    wNVideoCanvas.SetStylePackage('dark');
    wNVideoCanvas.SetVariable('isAutoStart', autoPlayVideo);

    this._wNVideoCanvas = wNVideoCanvas;
    this._reRenderWidget(clipId, autoPlayVideo);
  }

  _reRenderWidget = (clipId, autoPlayVideo = true) => {
    const { domCanvasId } = this.state;
    this.videoCanvas.classList.remove('vjsVideoCanvas');
    this._wNVideoCanvas.SetVariable('isAutoStart', autoPlayVideo);
    this._wNVideoCanvas.SetVariable('clipId', clipId);
    this._wNVideoCanvas.RenderWidget();
    document.querySelector(`#${domCanvasId} video`).addEventListener('ended', () => this._renderNextVideo());
  }

  _renderNextVideo() {
    const { videoItems, continuousPlaying, onPlayVideo, videoIndex } = this.props;
    const { clipId } = this.state;

    if (continuousPlaying && videoIndex < videoItems.length - 1) {
      onPlayVideo(videoIndex + 1);
    } else {
      this._reRenderWidget(clipId, false);
    }
  }

  render() {
    const { domCanvasId } = this.state;

    return (
      <div id={domCanvasId} ref={(node) => this.videoCanvas = node}></div>
    );
  }
}

export default VideoPlayerWrapper;



// WEBPACK FOOTER //
// ./app/components/media/VideoPlayer.js